import { CustomTheme } from 'themes/types'

import { makeStyles } from '@mui/styles'

import { theme, themeVariables } from 'themes'

export const newFormThemeOverrides = {
    MuiAlert: {
        styleOverrides: {
            root: {
                color: '#666666 !important',
                backgroundColor: '#FFFFFF !important',
                minHeight: 60,
                padding: 0,
                border: '1px solid #DDDDDD',
                marginBottom: 30,

                '&.swapMargin': {
                    marginTop: 30,
                    marginBottom: 0,
                },

                '&.authenticatorWarning': {
                    marginTop: 30,
                    marginBottom: 0,
                },
                '&.notification': {
                    marginBottom: 0,

                    '& .iconBox': {
                        backgroundColor: '#878E9F',
                    },
                },

                '&.notificationText': {
                    marginTop: 20,
                    marginBottom: 20,

                    '& .iconBox': {
                        backgroundColor: '#878E9F',
                    },
                },
                '&.info, &.Info': {
                    '& .iconBox': {
                        backgroundColor: '#878E9F',
                    },
                },
                '&.error, &.Error': {
                    '& .iconBox': {
                        backgroundColor: '#FA5849',
                    },
                },
                '&.success, &.Success': {
                    '& .iconBox': {
                        backgroundColor: '#60D956',
                    },
                },
                '&.warning, &.Warning': {
                    '& .iconBox': {
                        backgroundColor: '#FAB649 !important',
                    },
                    '& .iconBox-bright-red': {
                        backgroundColor: '#FA5849',
                    },
                },

                '& .message': {
                    alignSelf: 'center',
                    padding: '10px 20px',
                    fontSize: 16,
                    color: '#666666',
                    display: 'flex',
                    alignItems: 'center',

                    [theme.breakpoints.down('sm')]: {
                        padding: '6px 15px 6px 10px',
                        flexDirection: 'column',
                        alignItems: 'flex-start',

                        '& .textWrap': {
                            marginTop: 8,
                            marginBottom: 10,
                        },
                    },

                    '& .textWrap ~ .button, .textWrap ~ a': {
                        marginLeft: 15,

                        [theme.breakpoints.down('sm')]: {
                            marginLeft: 0,
                        },
                    },

                    '& button': {
                        width: 'max-content',
                        maxWidth: '250px',
                        minWidth: '130px',
                        color: '#000',

                        [theme.breakpoints.down('sm')]: {
                            marginBottom: 10,
                        },
                    },
                },
                '& .type': {
                    fontWeight: 700,
                    marginRight: 5,
                    verticalAlign: 'middle',
                    color: '#222222',
                },
                '& .type--no-caps': {
                    fontWeight: 600,
                    marginRight: 5,
                    verticalAlign: 'middle',
                    color: '#222222',
                },
                '& .text': {
                    verticalAlign: 'middle',
                },
                '& .iconBox': {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minWidth: 50,
                    maxWidth: 50,
                    borderTopLeftRadius: `${themeVariables.variables.checkbox.borderRadius}`,
                    borderBottomLeftRadius: `${themeVariables.variables.checkbox.borderRadius}`,
                    flex: '1 0 50px',
                },
                '& .iconImg': {
                    height: 20,
                    width: 20,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
            },
            message: {
                display: 'flex',
                flexDirection: 'row',
                fontSize: 16,
                margin: '-1px 0 -1px -1px',
                padding: 0,
                '& .text': {
                    marginRight: '5px',
                },
            },
            action: {
                padding: 0,
                margin: '0 0 0 auto',
                width: 50,
                alignItems: 'center',
                justifyContent: 'center',
            },
        },
    },
    MuiButton: {
        styleOverrides: {
            outlined: {
                borderRadius: `${themeVariables.variables.buttonOutlined.borderRadius}`,
                minWidth: 120,
                height: 32,
                borderColor: `${themeVariables.color.border.main}`,
                borderWidth: 1,
                fontSize: 14,
                fontWeight: 600,
                textTransform: 'none',
                '&:hover, &:active': {
                    backgroundColor: `${themeVariables.color.button.outlinedHover}`,
                    borderColor: `${themeVariables.color.border.active}`,
                },
            },
        },
    },
}

export const useSecurityWarningStyles = makeStyles((theme: CustomTheme) => ({
    paper: {
        width: '275px',
        height: 'auto',
        borderRadius: 'none',
        boxShadow: 'none',
        backgroundColor: '#E9394826',
        [theme.breakpoints.down('sm')]: {
            width: '85%',
        },
    },
    root: {
        backgroundColor: 'rgba(0, 0, 0, .3)',
    },
    fabRoot: {
        backgroundColor: 'transparent',
    },
    securityWarnFab: {
        display: ({ hideSecurityWarningAlert }: { hideSecurityWarningAlert: 'none' | 'flex' }) => hideSecurityWarningAlert,
        alignItems: 'center',
        justifyContent: 'center',
        width: '38px',
        height: '38px',
        cursor: 'pointer',
        boxShadow: 'none',
        position: 'relative',

        '& .security-warn-fab-img': {
            position: 'relative',
        },
        '&:hover': {
            backgroundColor: '#E9394840',
        },
    },
    securityPopoverBody: {
        overflowY: 'hidden',
    },

    securityPopoverContent: {
        backgroundColor: theme.palette.secondary.main,
        padding: '20px',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },

    securityPopoverHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
    },
    securityPopoverHeading: {
        color: theme.color.text.light,
        marginLeft: '20px',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '20px',
    },
    securityPopoverImg: {
        width: '35px',
        height: '32px',
    },
    securityPopoverTextHolder: {
        marginBottom: '20px',
        fontSize: '16px',
    },
    securityPopoverText: {
        display: 'inline-block',
        marginBottom: '20px',
        color: theme.color.text.muted,
        fontSize: '16px',
    },
    securityPopoverBtn: {
        minWidth: '134px',
        height: '32px',
        padding: '8px',
        border: `2px solid ${theme.color.text.light}`,
        borderRadius: '16px',
        color: theme.color.primary.white,
        fontSize: '12px',

        '&:hover, &:active': {
            borderColor: theme.color.button.outlinedHover,
            color: theme.color.button.outlinedHover,
        },
    },
    pulseButton: {
        animation: '$pulse 2s ease infinite',
        backgroundColor: '#E9394826',
        width: '38px',
        height: '38px',
        top: 0,
        position: 'absolute',
        borderRadius: '50%',
    },
    '@keyframes pulse': {
        '0%': {
            transform: 'scale(0.95)',
            boxShadow: '0 0 0 0 rgba(255, 52, 102, 1)',
        },
        '70%': {
            transform: 'scale(1)',
            boxShadow: '0 0 0 10px rgba(255, 52, 102, 0)',
        },
        '100%': {
            transform: 'scale(0.95)',
            boxShadow: '0 0 0 0 rgba(255, 52, 102, 0)',
        },
    },
}))
